<template>
  <div class="iCcard">
    <div class="content">
      <div class="iCcard-top">
        <div class="ic-left">
          <span style="margin-right:40px">IC卡管理</span>
        </div>
        <div class="btns">
          <div class="specification-tips">
            <i class="el-icon-question"></i>
            <span>导入IC卡请使用规范的Excl格式</span>
            <span class="view-btn" @click="dialogExcelRu = true">查看</span>
          </div>
          <el-upload action="" :show-file-list="false" :auto-upload="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            list-type="picture-card" :on-change="saveExcel_fn">
            <el-button type="primary" style="margin-left:15px">导入</el-button>
          </el-upload>
          <el-button type="primary" @click="dialogExcel = true">导出</el-button>
          <el-button type="primary" @click="add_ed(0)">新增</el-button>
          <el-button type="primary" @click="batchDel_fn" class="last-el-button del-btn-transfer">批量删除</el-button>
        </div>
      </div>
      <div class="search-input-btn">
        <div class="input-small">
          <span>绑定状态：</span>
          <el-select v-model="temp.statusType" placeholder="请选择" clearable @change="status_fn">
            <el-option v-for="item in statusList" :key="item.id" :label="item.label" :value="item.lable"> </el-option>
          </el-select>
        </div>
      </div>

      <div class="iCcard-table" :style="{'height':heights+'px'}">
        <el-table :data="tableData" v-loading="loading" border stripe style="width: 100%" :max-height="heights - 20"
          @selection-change="handleSelectionChange">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="selection" :selectable="selectable" width="44" align="center">
          </el-table-column>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardNum" label="卡号" width="351"> </el-table-column>
          <el-table-column label="绑定状态" width="351">
            <template slot-scope="scope">
              <span v-if="scope.row.state != 0" style="color: #368ED9;"> <i class="status blue"></i> 已绑定</span>
              <span v-else style="color: #999999;"><i class="status ash"></i> 未绑定</span>
            </template>
          </el-table-column>

          <el-table-column prop="remarks" label="备注" width="700"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box">

                <!-- <el-button type="text"  style="color:#FF7765;font-weight: bold" @click="del_fn(row)" >删除</el-button> -->
                <div @click="del_fn(row)" v-if="row.state == 0">
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <elIconBtn btnType='del'></elIconBtn>
                  </el-tooltip>
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->
    <el-dialog width="20%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
          <el-form-item label="卡号:" prop="cardNum">
            <el-input v-model="temp.cardNum" style=""></el-input>
          </el-form-item>

          <el-form-item label="备注:" prop="remarks">
            <el-input v-model="temp.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog width="20%" v-dialogDrag title="导出excel" :close-on-click-modal='false' :visible.sync="dialogExcel">
      <div style="display: flex;">
        <el-form :model="tempExcel" ref="tempExcel" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
          <el-form-item label="文件名:" prop="fileName">
            <el-input v-model="tempExcel.fileName" style="width:217px"></el-input>
          </el-form-item>
          <el-form-item label="卡状态:" prop="state">
            <el-select v-model="tempExcel.state" placeholder="请选择" clearable>
              <el-option v-for="item in statusList" :key="item.id" :label="item.lable" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogExcel = false">取 消</el-button>
        <el-button type="primary" @click="leadingOut">保存</el-button>
      </div>
    </el-dialog>
    <!-- 导入实例图片 -->
    <el-dialog width="25%" v-dialogDrag title="导入excel示例" :close-on-click-modal='false' :visible.sync="dialogExcelRu">
      <div style="display: flex;">
        <img src="../../assets/icCard.png" alt="">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogExcelRu = false">取 消</el-button>
        <el-button type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {findICCards,saveIcCard,deleteIcCard,icCardSaveExcel} from "../../api/zhongshanMeter";

  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      downloadTable,
      elIconBtn
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        //查询
        loading: true,
        statusType: "",
        statusList: [
          {
            lable: "已绑定",
            id: 1
          },

          {
            lable: "未绑定",
            id: 0
          },
        ],
        total: 0,
        currentPage: 1,
        currentSize: 15,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增IC卡",
          edit: "编辑IC卡"
        },
        //新增修改对象
        temp: {
          'cardNum': "",
          'remarks': "",
        },
        //星号必填
        rules: {
          cardNum: [
            {required: true,message: '请输入卡号',trigger: 'blur'}
          ]
        },
        //表格数据
        tableData: [],
        //表格选中
        multipleSelection: [],
        dialogExcel: false,//导出
        dialogExcelRu: false,//导入格式
        tempExcel: {
          fileName: 'icCard',
          state: ""
        }

      };
    },

    mounted () {
      this.getList()


    },
    computed: {

    },
    watch: {

    },

    methods: {
      //对复选框进行禁用操作
      selectable (row,index) {
        if(row.state==1) {
          return false //禁用，不允许删除
        } else {
          return true //允许删除
        }

      },
      //切换状态
      status_fn (val) {
        this.statusType=val
        this.getList()

      },
      //表格选中
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },
      //获取数据
      getList () {
        var d={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
        }
        if(this.statusType!="") {
          d.state=this.statusType=='已绑定'? 1:0
        }
        this.loading=true
        findICCards(d).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content
            this.total=res.data.totalElements
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查看失败')
            this.loading=false
          }
        })
      },
      //单个删除
      del_fn (row) {
        if(row.state==1) {
          this.$message({showClose: true,message: `此${row.cardNum}卡号已绑定，不可删除`,type: 'warning'});
          return
        }
        this.$confirm(`是否删除 ${row.cardNum}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteIcCard({"ids": row.id}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //批量删除
      batchDel_fn () {
        var strId=""
        if(this.multipleSelection.length==0) {
          this.$message({showClose: true,message: '请勾选需要删除的IC卡',type: 'warning'});
          return
        }
        this.multipleSelection.forEach(item => {
          strId+=','+item.id
        })
        this.$confirm(`是否批量删除已选中的IC卡`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteIcCard({"ids": strId.substr(1)}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //批量导入
      saveExcel_fn (file) {
        let data=new FormData();
        data.append("file",file.raw);
        this.loading=true
        icCardSaveExcel(data).then(res => {
          if(res.code==200) {
            this.getList()
            this.$message({showClose: true,message: res.data,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')

          }
        })
      },
      //导出
      leadingOut () {
        if(this.tempExcel.state=="") {
          window.open(DWSystemSetting.baseURL+'/icCard/findExcel?fileName='+this.tempExcel.fileName,"_blank");
          this.dialogExcel=false
          return
        }
        window.open(DWSystemSetting.baseURL+'/icCard/findExcel?fileName='+this.tempExcel.fileName+'&state='+this.tempExcel.state,"_blank");
        this.dialogExcel=false

      },





      // 添加弹窗
      add_ed (v,l) {
        this.temp.cardNum=''
        this.temp.remarks=''
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            saveIcCard(this.temp).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              "cardNum": data.cardNum,
              "id": data.id,
              "remarks": data.remarks,
            }
            saveIcCard(d).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('修改失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';

        this.temp=Object.assign({},v);

        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-IC卡管理','.iCcard-table')
      },
      //分页功能
      newgetNowPageDataList () {
        this.getList()
        // 当前页显示
        // this.total = this.tableData.length;
        // var result = this.tableData.filter((item, index) => {
        //   return index < this.currentPage * this.currentSize && index >= (this.currentPage - 1) * this.currentSize;
        // });

        // this.nowPageDataList = result;
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .iCcard {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 20px 20px 12px 20px;
      box-sizing: border-box;

      .iCcard-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #E6E6E6;
        padding-bottom: 12px;

        .ic-left {
          span {
            font-size: 16px;
            color: #1a1a1a;
          }
        }

        /deep/.el-upload--picture-card {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border: 0px;
        }

        .btns {
          display: flex;
          align-items: center;
        }

      }

      .iCcard-table {

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #368ED9;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 54px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }




  }
</style>